module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/error-pic@3x-acb37b219b8d78197595f56ab4ba1879.jpg";